export default __webpack_public_path__ + "static/media/placeholder_dummy2016-raumgestalter01-mobile-de.a8470350.png";